import { Honeycomb } from "src/app/services/honeycomb-api/honeycomb-api";

export const CustomSpTypes = () => [
    {
        type: 'tasker.spTaskSummaryCreateMultipleTasks',
        paramsFn: (zeroPointsItems: Array<{ // zero point items model
            value: any,
            input: any,
            followUpTask: any,
            caption: string
        }>, context?: { langIsoCode?: string | null }) => {
            const activities = zeroPointsItems.filter(a => !a.followUpTask);
            let parentSnapshotInputIDs = [];
            let parentTaskValueIDs = [];
            activities.forEach(a => {
                if (a.input.isSnapshot) {
                    parentSnapshotInputIDs.push(a.input.inputID);
                } else {
                    parentTaskValueIDs.push(a.input.taskValueID);
                }
            });

            const langIsoCode = context?.langIsoCode && String(context.langIsoCode).trim()
                ? String(context.langIsoCode).trim()
                : null;

            return {
                taskValueIDs: parentTaskValueIDs,
                snapshotInputIDs: parentSnapshotInputIDs,
                ...(langIsoCode ? { Lang: [langIsoCode] } : {})
            };
        },
        visibleFn: (zeroPointsItems: Array<{ // zero point items model
            value: any,
            input: any,
            followUpTask: any,
            caption: string
        }>): boolean => {
            return zeroPointsItems.filter(a => !a.followUpTask).length > 0;
        }
    }
]